import { findChildrenByType } from 'prosemirror-utils';
/**
 *
 * @param state current editor state
 * @param collapsibleSection collapsible section (commonly obtained through findParentNodeOfType helper method)
 * @param childType collapsibleSectionSummary or collapsibleSectionContent type
 * @returns resolved position of the child node (content or summary) for the given collapsible section
 */
export function getCollapsibleSectionChildPos(state, collapsibleSection, childType) {
  let {
    doc
  } = state;
  let collapsibleSectionChildren = findChildrenByType(collapsibleSection.node, childType, false);
  let collapsibleSectionChildOffset = collapsibleSectionChildren[0].pos;
  return doc.resolve(collapsibleSection.start + collapsibleSectionChildOffset + 1);
}
export function parentIsCollapsibleSectionSummary(state) {
  let {
    schema,
    selection
  } = state;
  let anchor = selection.$anchor;
  try {
    let positionAfter = anchor.doc.resolve(anchor.after());
    let parent = positionAfter.parent;
    return parent.type === schema.nodes.collapsibleSectionSummary;
  } catch (e) {
    return false;
  }
}
export function parentIsCollapsibleSectionContent(state) {
  let {
    schema,
    selection
  } = state;
  let anchor = selection.$anchor;
  try {
    let positionAfter = anchor.doc.resolve(anchor.after());
    let parent = positionAfter.parent;
    return parent.type === schema.nodes.collapsibleSectionContent;
  } catch (e) {
    return false;
  }
}
export function getAllCollapsibleSections(prosemirrorState) {
  return findChildrenByType(prosemirrorState.doc, prosemirrorState.schema.nodes.collapsibleSection);
}
export function toggleSectionOpen(composer, sectionWithPos) {
  composer.commands.updateNodeAttributesAtPosition(sectionWithPos.node, sectionWithPos.pos, {
    open: !sectionWithPos.node.attrs.open
  });
}